export default __webpack_public_path__ + "media/images/87-813b58129ec289a6cfd411b8cd4182d8.jpg";